import React from 'react'
import styled from 'styled-components'

import { Button } from '../../styles/Buttons'
import { Heading2, Heading5, Paragraph, ParagraphStyles } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Text = styled(Paragraph)`
  margin-bottom: 48px;
`

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  column-gap: 32px;
  margin-bottom: 48px;
`

const Item = styled.div`
  width: 100%;
  padding: 6px;
  background-color: #ff8de3;
  border-radius: 4px;
  ${ParagraphStyles};
  text-align: center;
  ${(p) => p.columns && `grid-column: span ${p.columns}`}
`

const SpacingsElement = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 16px;
  background-color: #f3ddf2;
  > * {
    background-color: #f0f1f8;
  }
  :before {
    content: '16px';
    position: absolute;
    top: 50%;
    left: -12px;
    padding: 0px 8px;
    transform-origin: center;
    transform: translateY(-50%) rotate(-90deg);
    background-color: #ff8de2;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
  }
  :after {
    content: '16px';
    position: absolute;
    top: 50%;
    right: -12px;
    padding: 0px 8px;
    transform-origin: center;
    transform: translateY(-50%) rotate(-90deg);
    background-color: #ff8de2;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
  }
`

const SpacingsElementHeading = styled(Heading5)``

const SpacingsElementParagraph = styled(Paragraph)``

const SpacingsElementButton = styled.div``

const Spacer = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 8px;
  background-color: #ff8de2;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  align-self: center;
  ${(p) => p.height && `height: ${p.height};`}
`

const GridsAndLayout = () => {
  return (
    <>
      <Heading>Grids and layout</Heading>
      <Text>
        Our flexible layouts are based upon on multiples of 12 columns, with a fluid gutter and margins using the ratios
        of the 8pt grid system.
      </Text>
      <Row>
        <Item columns={4}>1/2</Item>
        <Item columns={4}>1/2</Item>
      </Row>
      <Row>
        <Item columns={2}>1/4</Item>
        <Item columns={2}>1/4</Item>
        <Item columns={2}>1/4</Item>
        <Item columns={2}>1/4</Item>
      </Row>
      <Row>
        <Item columns={2}>2/8</Item>
        <Item columns={6}>6/8</Item>
      </Row>
      <Row>
        <Item columns={5}>5/8</Item>
        <Item columns={3}>3/8</Item>
      </Row>
      <Text>
        Multiples of the 8pt system should be used to define dimensions, padding, and margin of both block and inline
        elements.
      </Text>
      <SpacingsElement>
        <Spacer>16px</Spacer>
        <SpacingsElementHeading>Realtime charts and graphs</SpacingsElementHeading>
        <Spacer height="24px">24px</Spacer>
        <SpacingsElementParagraph>
          Update dashboards in realtime, whatever the metric: stock tickers, cryptocurrency prices, application metrics,
          and more.
        </SpacingsElementParagraph>
        <Spacer>16px</Spacer>
        <SpacingsElementButton>
          <Button dark>Find out more</Button>
        </SpacingsElementButton>
        <Spacer>16px</Spacer>
      </SpacingsElement>
    </>
  )
}

export default GridsAndLayout
